import React from 'react'

const Aboutus = () => {
  return (
    <h1 className='h-100 pt-5 mt-5 pb-5 mb-5 text-center'>Coming Soon ...........</h1>
  )
}

export default Aboutus